module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAgCAMAAABemGpIAAAAAXNSR0IB2cksfwAAADNQTFRFAAAA////////////////////////////////////////////////////////////////t5XiggAAABF0Uk5TABCP3/+QcJ/vsKBA8MC/4G9a6BY+AAAAhElEQVR4nM3UyQrAIAwE0KSOdnPp/39tka5QJBFq6Vzi4R0yChJ3BqqYjsnqaI4lA0eqOBgCdJaybI25H/YWPYt4vDpPIgbm7TRjUGC6nUSc0wZXrXEW9CKuujoe/WHlR9HkbzjkbrE8nziU55c7H4k1OLy5RgucsOjsglT3MbJNOposr490CHNROhTMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/billing-icon-active@2x.png
// module id = 720
// module chunks = 0